import React from 'react'
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import MuiAlert from '@material-ui/lab/Alert';
export default function MySnackbar(props) 
{
    const {show,message,type}=props;
  return <> <Snackbar
    open={show}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    autoHideDuration={3000} 
    onClose={props.onClose}
  >
     
    <Alert severity={type} variant="filled">{message}</Alert>
  </Snackbar>
  </>
}

MySnackbar.defaultProps={
    show:false,
    message:'Snackbar',
    type:'info'
}